import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/assets/js/rem.js';
import { Provider } from 'react-redux';
import store from './store';
import '@/assets/styles/common.scss';
import './theme.css';
import '@/assets/css/reset.css';
import zhCN from 'antd/es/locale/zh_CN';
import { ConfigProvider } from 'antd';
import { AliveScope } from 'react-activation';
import App from './App';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AliveScope>
    <ConfigProvider locale={zhCN}>
      <Provider store={store}>
        <App />
      </Provider>
    </ConfigProvider>
  </AliveScope>
);